import React from "react";
import PropTypes from "prop-types";

import EditIcon from "components/icons/EditIcon";
import MembersIcon from "components/icons/MembersIcon";

import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Switch,
  Divider,
} from "@mui/material";

const listItems = [
  {
    id: "cover_image",
    label: "Header Image",
    icon: <EditIcon />,
  },
  {
    id: "logo",
    label: "Profile Picture",
    icon: <EditIcon />,
  },
  {
    id: "title",
    label: "Name/Title",
    icon: <EditIcon />,
  },
  {
    id: "member_count",
    label: "Number of Members",
    icon: <MembersIcon />,
    switchName: "hide_members_count",
    onClick: () => alert("Member count is auto-updated based on subscribers"),
  },
  {
    id: "custom_cta",
    label: "Call to Action",
    switchName: "hide_cta",
    icon: <EditIcon />,
  },
  {
    id: "description",
    label: "Bio/Description",
    switchName: "hide_description",
    icon: <EditIcon />,
  },
  {
    id: "social_links",
    label: "Social Links",
    switchName: "hide_social_links",
    icon: <EditIcon />,
  },
];

const DetailsList = ({ organization, onOrganizationChange, onEdit }) => {

  const handleToggle = (field) => () => {
    const newOrganization = {
      ...organization,
      preferences: {
        ...organization.preferences,
        [field]: !organization.preferences?.[field]
      }
    };

    onOrganizationChange(newOrganization);
  };

  return (
    <List sx={{ py: 0 }}>
      {listItems.map((element, index) => (
        <React.Fragment key={element.id}>
          <ListItem>
            <ListItemText
              primary={element.label}
              primaryTypographyProps={{ fontSize: 14 }}
            />
            <ListItemSecondaryAction
              sx={{ display: "flex", alignItems: "center" }}
            >
              <IconButton
                edge="end"
                aria-label="edit"
                onClick={element.onClick || onEdit(element.id)}
                sx={{ mr: 1 }}
              >
                {element.icon}
              </IconButton>
              {element.switchName && (
                <Switch
                  edge="end"
                  color="warning"
                  checked={organization.preferences?.[element.switchName]}
                  onChange={handleToggle(element.switchName)}
                  inputProps={{
                    "aria-labelledby": `${element.switchName}-switch`,
                  }}
                  size="small"
                />
              )}
            </ListItemSecondaryAction>
          </ListItem>
          {index < listItems.length - 1 && <Divider component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
};

DetailsList.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
  onEdit: PropTypes.func,
};

export default DetailsList;
